export const translateApiProperty = (record, property, locale) => {
  if (!record) return;

  if (record.i18n && record.i18n[locale] && record.i18n[locale][property]) return record.i18n[locale][property]
  return record[property];
}
